import { CheckIcon } from "@heroicons/react/20/solid";

const includedFeatures1 = [
  "Solutions adaptées au bien-être des salariés",
  "Ateliers sur mesure",
  "Promotion de la cohésion d'équipe",
  "Suivi et évaluation des participants",
];

export default function Example() {
  return (
    <div className="bg-white pb-24 sm:pb-32">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <div className="mx-auto mt-16 rounded-3xl ring-1 ring-gray-200 sm:mt-20 lg:mx-0 lg:flex lg:max-w-none">
          <div className="p-8 sm:p-10 lg:flex-auto">
            <h3 className="text-crd-title font-bold uppercase font-sans mb-2">
              prestations collectives
            </h3>

            <div className="mt-10 flex items-center gap-x-4">
              <h4 className="flex-none text-sm font-semibold leading-6 text-[#9BDAF2]">
                Ces prestations contiennent
              </h4>
              <div className="h-px flex-auto bg-gray-100" />
            </div>
            <ul className="mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-[#020617] sm:grid-cols-2 sm:gap-6">
              {includedFeatures1.map((feature) => (
                <li key={feature} className="flex gap-x-3">
                  <CheckIcon
                    aria-hidden="true"
                    className="h-6 w-5 flex-none text-[#9BDAF2]"
                  />
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          <div className="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:flex-shrink-0">
            <div className="rounded-2xl bg-gray-50 py-10 text-center ring-1 ring-inset ring-gray-900/5 lg:flex lg:flex-col lg:justify-center lg:py-16">
              <div className="mx-auto max-w-xs px-8">
                <p className="mt-6 flex items-baseline justify-center gap-x-2">
                  <span className="text-h2 font-sans font-bold">100€ /h</span>
                </p>
                <p className="mt-6 text-xs leading-5 text-[#020617]">
                  Pour un groupe de +10 personnes
                </p>
                <a
                  href="#contact"
                  className="mt-10 block w-full rounded-md bg-[#9BDAF2] px-3 py-2 text-center text-sm font-semibold text-white shadow-sm"
                >
                  Me contacter
                </a>
                <p className="mt-6 text-xs leading-5 text-[#020617]">
                  10€ /personne pour un groupe de 4 à 10 personnes
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
